import messages_en from './en';
import messages_esp from './esp';
import messages_fr from './fr';
import messages_zhhant from './zhhant';
import messages_vi from './vi';
import messages_fil from './fil';
import messages_zhhans from './zhhans';
import messages_ar from './ar';
import { LANGUAGE_OPTIONS } from './locales';

export { LANGUAGE_OPTIONS };

const RAW_MESSAGES = {
  EN: messages_en,
  ES: messages_esp,
  FR: messages_fr,
  VI: messages_vi,
  'ZH-HANT': messages_zhhant,
  FIL: messages_fil,
  'ZH-HANS': messages_zhhans,
  AR: messages_ar,
};

const MESSAGES = Object.fromEntries(
  Object.entries(RAW_MESSAGES).map(([locale, messages]) => {
    if (locale === 'EN') {
      return [locale, messages];
    }

    // Keep missing keys from breaking UI by falling back to EN messages.
    return [locale, { ...messages_en, ...messages }];
  })
);

export default MESSAGES;
